import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  ja: {
    common: {
      loading: '読み込み中...',
      cancel: 'キャンセル',
      edit: '編集'
    },
    home: {
      hotProducts: '人気商品',
      viewAll: 'すべて見る',
      announcement: 'お知らせ',
      customerService: 'カスタマーサービス',
      noProducts: '商品がありません',
      platformAnnouncement: 'プラットフォームお知らせ',
      selectAnnouncementTip: '表示するお知らせを選択してください',
      contactCustomerService: 'カスタマーサービスにお問い合わせ',
      scanQRCodeTip: 'QRコードをスキャンしてカスタマーサービスに連絡',
      noCustomerQR: 'カスタマーサービスのQRコードがありません',
      navProcess: '【お知らせ】取引の流れ',
      navUnfreeze: '【お知らせ】VIPサービス',
      navSafety: '【お知らせ】ゲームデータやSNSアカウントの無断送信は禁止',
      navRules: '【お知らせ】解凍業務',
      navContact: '【お知らせ】チャージと引き出し時間',
      navJiHuo: '【お知らせ】アカウントの有効化',
      notifications: 'お知らせ',
      noNotifications: '通知がありません',
      markAsRead: '既読にする'
    },
    register: {
      title: '登録',
      username: 'ユーザー名',
      usernameHint: 'ユーザー名を入力してください',
      usernameRule: 'ユーザー名は3-20文字である必要があります',
      password: 'パスワード',
      passwordHint: 'パスワードを入力してください',
      passwordRule: 'パスワードは6文字以上である必要があります',
      registering: '登録中...',
      submit: '登録',
      hasAccountText: 'アカウントをお持ちですか？',
      loginNow: '今すぐログイン'
    },
    product: {
      editTitle: '商品を編集',
      uploadTitle: '商品をアップロード',
      editSubtitle: '商品情報を変更',
      uploadSubtitle: '販売する新しい商品を追加',
      name: '商品名',
      nameHint: '商品名を入力してください',
      nameRule: '商品名は必須です',
      price: '価格',
      priceHint: '円で価格を入力してください',
      priceRule: '価格は正の数である必要があります',
      description: '説明',
      descriptionHint: '商品説明を入力してください',
      descriptionRule: '説明は必須です',
      image: '商品の画像',
      selectImage: '画像を選択',
      reSelectImage: '画像を再選択',
      updating: '更新中...',
      submitting: '送信中...'
    },
    products: {
      searchPlaceholder: '商品を検索...',
      newest: '最新',
      priceLowToHigh: '価格：安い順',
      priceHighToLow: '価格：高い順',
      search: '検索',
      empty: '商品が見つかりません',
      emptySubtext: '検索条件を調整するか商品をアップロードしてください',
      upload: '商品をアップロード'
    },
    noAccountText: 'アカウントをお持ちでない方',
    registerNow: '今すぐ登録',
    login: {
      title: 'ログイン',
      usernameHint: 'ユーザー名を入力してください',
      passwordHint: 'パスワードを入力してください',
      rememberUsername: 'ユーザー名を記憶',
      rememberPassword: 'パスワードを記憶',
      loggingIn: 'ログイン中...',
      submit: 'ログイン',
      noAccountText: 'アカウントをお持ちでない方',
      registerNow: '今すぐ登録',
      completeInfo: 'ユーザー名とパスワードを入力してください',
      success: 'ログイン成功',
      error: 'ログイン失敗',
      retry: 'もう一度お試しください'
    },
    nav: {
      home: 'ホーム',
      buy: '購入',
      sell: 'ゲームを売る',
      profile: 'ユーザー設定',
      login: 'ログイン',
      logout: 'ログアウト',
      admin: '管理者'
    },
    site: {
      title: '商品取引'
    },
    tips: {
      title: 'ご案内',
      reviewRequired: '商品の提出後に管理者の審査が必要',
      updateReviewRequired: '商品更新後に管理者による再審査が必要',
      ensureValid: '商品情報が実際に有効であることを確認してください',
      statusReset: '編集後の商品ステータスはレビュー対象にリセットされます'
    },
    profile: {
      title: '個人情報',
      personalInfo: '個人情報',
      balance: 'アカウント残高',
      myProducts: '販売中の商品',
      withdrawalHistory: '出金履歴',
      username: 'ユーザー名',
      realName: '本名',
      phone: '電話番号',
      email: 'メールアドレス',
      emailPlaceholder: 'メールアドレスを入力してください',
      emailHelp: '重要な通知の受信に使用されます',
      emailInvalid: 'メールアドレスの形式が正しくありません',
      bankAccount: '銀行口座',
      address: '連絡先',
      katakanaName: 'カタカナ名',
      delete: '削除',
      productDetails: '商品詳細',
      productName: '商品名',
      productPrice: '商品価格',
      productImage: '商品画像',
      seller: '出品者',
      reviewStatus: '審査状況',
      saleStatus: '販売状況',
      content: '内容',
      rejectionReason: '拒否理由',
      publishTime: '公開日時',
      updateTime: '更新日時',
      noDescription: '説明なし',
      noWithdrawalRecords: '出金履歴なし',
      confirmDeleteWithdrawal: 'この出金履歴を削除しますか？',
      deleteSuccess: '削除成功',
      deleteFailed: '削除失敗',
      withdrawalSubmitted: '出金申請が提出されました。審査待ちです。',
      available: '販売中',
      sold: '売却済み',
      removed: '販売停止',
      usernameHelp: 'ユーザー名はログインに使用され、変更可能ですが他のユーザーと重複できません',
      realNameHelp: '出金時に確認が必要です',
      katakanaNameHelp: '対応するカタカナ名を記入してください',
      phoneHelp: '重要な通知に使用されます',
      bankAccountHelp: '出金時に使用されます',
      bankName: '銀行名',
      bankNamePlaceholder: '銀行名を入力してください',
      bankNameHelp: '銀行名を入力してください',
      bankNameRequired: '銀行名は空にできません',
      bankBranch: '支店名',
      bankBranchPlaceholder: '支店名を入力してください',
      bankBranchHelp: '支店名を入力してください',
      bankBranchRequired: '支店名は空にできません',
      idCardFront: '身分証明書（表）',
      idCardFrontHelp: '身分証明書の正面画像をアップロードしてください（任意）',
      idCardBack: '身分証明書（裏）',
      idCardBackHelp: '身分証明書の裏面画像をアップロードしてください（任意）',
      uploadSuccess: 'アップロードが成功しました',
      uploadFailed: 'アップロードに失敗しました',
      addressHelp: '郵送または連絡に使用されます',
      requiredNote: '必須項目は出金前に入力してください',
      save: '保存',
      applyWithdrawal: '出金申請',
      noProducts: '商品がありません',
      viewDetails: '詳細を見る',
      remainingAmount: '残り出金額',
      totalAmount: '総額',
      invalidUserInfo: 'ユーザー情報が無効です',
      loadProfileFailed: 'ユーザープロフィールの取得に失敗しました',
      loadProfileFailedRetry: 'ユーザープロフィールの取得に失敗しました。もう一度お試しください',
      correctFormErrors: 'フォームのエラーを修正してください',
      saveSuccess: 'プロフィール保存成功',
      usernameExists: 'ユーザー名は既に他のユーザーによって使用されています',
      phoneFormatInvalid: '電話番号の形式が正しくありません',
      saveFailedRetry: '保存に失敗しました。後でもう一度お試しください',
      realNamePlaceholder: '本名を入力してください',
      katakanaNamePlaceholder: 'カタカナ名を入力してください',
      phonePlaceholder: '電話番号を入力してください',
      bankAccountPlaceholder: '銀行口座を入力してください',
      addressPlaceholder: '詳細な住所を入力してください',
      usernameRequired: 'ユーザー名は空にできません',
      usernameMinLength: 'ユーザー名は少なくとも3文字である必要があります',
      usernameMaxLength: 'ユーザー名は20文字を超えることはできません',
      usernameInvalid: 'ユーザー名は英字、数字、アンダースコア、中国語のみを含むことができます',
      realNameRequired: '本名は空にできません',
      realNameMinLength: '本名は少なくとも2文字である必要があります',
      realNameMaxLength: '本名は10文字を超えることはできません',
      realNameInvalid: '本名は中国語、英字、スペースのみを含むことができます',
      katakanaNameRequired: 'カタカナ名は空にできません',
      katakanaNameMinLength: 'カタカナ名は少なくとも2文字である必要があります',
      katakanaNameMaxLength: 'カタカナ名は20文字を超えることはできません',
      phoneRequired: '電話番号は空にできません',
      bankAccountRequired: '銀行口座は空にできません',
      addressRequired: '連絡先住所は空にできません',
      loadWithdrawalFailed: '出金履歴の読み込みに失敗しました',
      accountFrozen: 'アカウントは凍結されています。スタッフに連絡してください',
      checkUserStatusFailed: 'ユーザーステータスのチェックに失敗しました',
      checkUserStatusFailedRetry: 'ユーザーステータスのチェックに失敗しました。後でもう一度お試しください',
      completeProfileFirst: '出金申請前にプロフィール情報を完成させてください',
      insufficientBalance: '残高が不足しています。出金申請ができません',
      confirmWithdrawal: '{amount}円の出金を申請しますか？出金後、残高はゼロになります。',
      withdrawalSubmitted: '出金申請が提出されました。審査待ちです。',
      withdrawalFailed: '出金申請に失敗しました',
      withdrawalFailedRetry: '出金申請に失敗しました。後でもう一度お試しください',
      deleteWithdrawalFailed: '出金履歴の削除に失敗しました',
      deleteFailedRetry: '削除に失敗しました。後でもう一度お試しください',
      statusApproved: '承認済み',
      statusPending: '送金中',
      sellStatusPending: '審査中',
      statusRejected: '拒否',
      statusFrozen: '凍結中、スタッフに連絡してください',
      statusUnknown: '不明',
      statusAvailable: '販売中',
      statusSold: '売却済み',
      statusRemoved: '販売停止',
      requiredField: 'この項目は必須です'
    },
    detail: {
      back: '戻る',
      publishTime: '公開時間',
      productDescription: '商品説明',
      sellerInfo: '出品者情報',
      seller: '出品者',
      productStatus: '商品状態',
      purchase: '購入',
      productNotFound: '商品が存在しません',
      productNotFoundMessage: '申し訳ありませんが、アクセスした商品は存在しないか、または販売停止されています',
      statusAvailable: '販売中',
      statusSold: '購入済み',
      statusReserved: '予約済み',
      statusUnknown: '不明',
      confirmPurchase: '{name}を購入しますか？価格：{price}円',
      purchaseSuccess: '購入成功！商品は販売済みとしてマークされ、出品者の残高が増加しました。',
      purchaseFailed: '購入に失敗しました',
      purchaseFailedRetry: '購入に失敗しました。後でもう一度お試しください',
      unknownSeller: '不明な出品者',
      loadProductFailed: '商品詳細の取得に失敗しました'
    },
    products: {
      statusAvailable: '販売中',
      statusSold: '販売済み',
      statusReserved: '予約済み'
    },
    nav: {
      home: 'ホーム',
      buy: '購入',
      sell: 'ゲームを売る',
      profile: 'ユーザー設定',
      login: 'ログイン',
      logout: 'ログアウト',
      admin: '管理者',
      confirmLogout: 'ログアウトしてもよろしいですか？',
      logoutSuccess: 'ログアウトしました',
      logoutFailed: 'ログアウトに失敗しました',
      logoutFailedRetry: 'ログアウトに失敗しました。もう一度お試しください'
    },
    withdrawal: {
      completeProfileFirst: '出金申請前にプロフィール情報を完成させてください',
      completeProfile: 'プロフィール情報を完成させてください',
      validAmount: '有効な出金額を入力してください',
      amountExceedsBalance: '出金額は現在の残高を超えることはできません',
      submitted: '出金申請が提出されました。審査待ちです。',
      failed: '出金申請に失敗しました',
      failedRetry: '出金申請に失敗しました。後でもう一度お試しください'
    }
  },
  en: {
    common: {
      loading: 'Loading...',
      cancel: 'Cancel',
      edit: 'Edit',
      confirm: 'Confirm'
    },
    home: {
      hotProducts: 'Hot Products',
      viewAll: 'View All',
      announcement: 'Announcement',
      customerService: 'Customer Service',
      noProducts: 'No products available',
      platformAnnouncement: 'Platform Announcement',
      selectAnnouncementTip: 'Please select an announcement to view',
      contactCustomerService: 'Contact Customer Service',
      scanQRCodeTip: 'Scan QR code to contact customer service',
      noCustomerQR: 'No customer service QR code available',
      navProcess: '[Notice] Transaction Process',
      navUnfreeze: '[Notice] VIP Service',
      navSafety: '[Notice] Unauthorized Sending of Game Data and SNS Accounts is Prohibited',
      navRules: '[Notice] Unfreeze Business',
      navContact: '[Notice] Charge and Withdrawal Time',
      navJiHuo: '[Notice] Account Activation',
      notifications: 'Notifications',
      noNotifications: 'No notifications',
      markAsRead: 'Mark as Read'
    },
    register: {
      title: 'Register',
      username: 'Username',
      usernameHint: 'Enter your username',
      usernameRule: 'Username must be 3-20 characters',
      password: 'Password',
      passwordHint: 'Enter your password',
      passwordRule: 'Password must be at least 6 characters',
      registering: 'Registering...',
      submit: 'Register',
      hasAccountText: 'Already have an account?',
      loginNow: 'Login Now'
    },
    product: {
      editTitle: 'Edit Product',
      uploadTitle: 'Upload Product',
      editSubtitle: 'Modify your product information',
      uploadSubtitle: 'Add a new product for sale',
      name: 'Product Name',
      nameHint: 'Enter product name',
      nameRule: 'Product name is required',
      price: 'Price',
      priceHint: 'Enter price in yen',
      priceRule: 'Price must be a positive number',
      description: 'Description',
      descriptionHint: 'Enter product description',
      descriptionRule: 'Description is required',
      image: 'Product Image',
      selectImage: 'Select Image',
      reSelectImage: 'Re-select Image',
      updating: 'Updating...',
      submitting: 'Submitting...'
    },
    products: {
      searchPlaceholder: 'Search products...',
      newest: 'Newest',
      priceLowToHigh: 'Price: Low to High',
      priceHighToLow: 'Price: High to Low',
      search: 'Search',
      empty: 'No products found',
      emptySubtext: 'Try adjusting your search or upload a product',
      upload: 'Upload Product'
    },
    noAccountText: 'Don\'t have an account?',
    registerNow: 'Register now',
    login: {
      title: 'Login',
      usernameHint: 'Enter your username',
      passwordHint: 'Enter your password',
      rememberUsername: 'Remember username',
      rememberPassword: 'Remember password',
      submit: 'Login',
      loggingIn: 'Logging in...',
      completeInfo: 'Please enter your username and password',
      success: 'Login successful',
      error: 'Login failed',
      retry: 'Please try again',
      noAccountText: 'Don\'t have an account?',
      registerNow: 'Register now'
    },
    nav: {
      home: 'Home',
      buy: 'Buy',
      sell: 'Sell Your Game',
      profile: 'User Settings',
      login: 'Login',
      logout: 'Logout',
      admin: 'Admin'
    },
    site: {
      title: 'Product Trading'
    },
    tips: {
      title: 'Tips',
      reviewRequired: 'Product submission requires admin review',
      updateReviewRequired: 'Product updates require admin re-review',
      ensureValid: 'Please ensure product information is accurate',
      statusReset: 'Product status will reset to pending after editing'
    },
    profile: {
      title: 'Personal Info',
      personalInfo: 'Personal Info',
      balance: 'Account Balance',
      myProducts: 'My Products',
      withdrawalHistory: 'Withdrawal History',
      username: 'Username',
      realName: 'Real Name',
      phone: 'Phone Number',
      email: 'Email',
      emailPlaceholder: 'Please enter your email',
      emailHelp: 'Used for important notifications',
      emailInvalid: 'Email format is incorrect',
      bankAccount: 'Bank Account',
      bankName: 'Bank Name',
      bankNamePlaceholder: 'Enter bank name',
      bankNameHelp: 'Enter your bank name',
      bankNameRequired: 'Bank name cannot be empty',
      bankBranch: 'Branch Name',
      bankBranchPlaceholder: 'Enter branch name',
      bankBranchHelp: 'Enter your branch name',
      bankBranchRequired: 'Branch name cannot be empty',
      idCardFront: 'ID Card Front',
      idCardFrontHelp: 'Upload the front side of your ID card (optional)',
      idCardBack: 'ID Card Back',
      idCardBackHelp: 'Upload the back side of your ID card (optional)',
      uploadSuccess: 'Upload successful',
      uploadFailed: 'Upload failed',
      address: 'Address',
      katakanaName: 'Katakana Name',
      delete: 'Delete',
      productDetails: 'Product Details',
      productName: 'Product Name',
      productPrice: 'Product Price',
      productImage: 'Product Image',
      seller: 'Seller',
      reviewStatus: 'Review Status',
      saleStatus: 'Sale Status',
      content: 'Content',
      rejectionReason: 'Rejection Reason',
      publishTime: 'Publish Time',
      updateTime: 'Update Time',
      noDescription: 'No Description',
      noWithdrawalRecords: 'No Withdrawal Records',
      confirmDeleteWithdrawal: 'Are you sure to delete this withdrawal record?',
      deleteSuccess: 'Delete Success',
      deleteFailed: 'Delete Failed',
      withdrawalSubmitted: 'Withdrawal application submitted, pending review',
      available: 'Available',
      sold: 'Sold',
      removed: 'Removed',
      usernameHelp: 'Username is used for login, can be modified but cannot duplicate with other users',
      realNameHelp: 'Required for withdrawal verification',
      katakanaNameHelp: 'Please fill in the corresponding katakana name',
      phoneHelp: 'Used for important notifications',
      bankAccountHelp: 'Used for withdrawals',
      addressHelp: 'Used for mailing or contact',
      requiredNote: 'Required fields must be completed before withdrawal',
      save: 'Save',
      applyWithdrawal: 'Apply for Withdrawal',
      noProducts: 'No products yet',
      viewDetails: 'View Details',
      remainingAmount: 'Remaining Amount',
      totalAmount: 'Total Amount',
      invalidUserInfo: 'Invalid user information',
      loadProfileFailed: 'Failed to get user profile',
      loadProfileFailedRetry: 'Failed to get user profile, please try again',
      correctFormErrors: 'Please correct errors in the form',
      saveSuccess: 'Profile saved successfully',
      usernameExists: 'Username is already used by other users',
      phoneFormatInvalid: 'Phone number format is incorrect',
      saveFailedRetry: 'Save failed, please try again later',
      realNamePlaceholder: 'Please enter real name',
      katakanaNamePlaceholder: 'Please enter katakana name',
      phonePlaceholder: 'Please enter phone number',
      bankAccountPlaceholder: 'Please enter bank account',
      addressPlaceholder: 'Please enter detailed address',
      usernameRequired: 'Username cannot be empty',
      usernameMinLength: 'Username must be at least 3 characters',
      usernameMaxLength: 'Username cannot exceed 20 characters',
      usernameInvalid: 'Username can only contain letters, numbers, underscores and Chinese',
      realNameRequired: 'Real name cannot be empty',
      realNameMinLength: 'Real name must be at least 2 characters',
      realNameMaxLength: 'Real name cannot exceed 10 characters',
      realNameInvalid: 'Real name can only contain Chinese, English and spaces',
      katakanaNameRequired: 'Katakana name cannot be empty',
      katakanaNameMinLength: 'Katakana name must be at least 2 characters',
      katakanaNameMaxLength: 'Katakana name cannot exceed 20 characters',
      phoneRequired: 'Phone number cannot be empty',
      bankAccountRequired: 'Bank account cannot be empty',
      addressRequired: 'Address cannot be empty',
      loadWithdrawalFailed: 'Failed to load withdrawal records',
      accountFrozen: 'Account is frozen, please contact staff',
      checkUserStatusFailed: 'Failed to check user status',
      checkUserStatusFailedRetry: 'Failed to check user status, please try again later',
      completeProfileFirst: 'Please complete your profile information before applying for withdrawal',
      insufficientBalance: 'Insufficient balance, cannot apply for withdrawal',
      confirmWithdrawal: 'Are you sure to apply for withdrawal {amount}円? Balance will be zero after withdrawal.',
      withdrawalSubmitted: 'Withdrawal application submitted, pending review',
      withdrawalFailed: 'Withdrawal application failed',
      withdrawalFailedRetry: 'Withdrawal application failed, please try again later',
      deleteWithdrawalFailed: 'Failed to delete withdrawal record',
      deleteFailedRetry: 'Delete failed, please try again later',
      statusApproved: 'Approved',
      statusPending: 'Pending',
      statusRejected: 'Rejected',
      statusFrozen: 'Frozen, please contact staff',
      statusUnknown: 'Unknown',
      statusAvailable: 'Available',
      statusSold: 'Sold',
      statusRemoved: 'Removed',
      requiredField: 'This field is required'
    },
    detail: {
      back: 'Back',
      publishTime: 'Publish Time',
      productDescription: 'Product Description',
      sellerInfo: 'Seller Information',
      seller: 'Seller',
      productStatus: 'Product Status',
      purchase: 'Purchase',
      productNotFound: 'Product Not Found',
      productNotFoundMessage: 'Sorry, the product you are looking for does not exist or has been removed',
      statusAvailable: 'Available',
      statusSold: 'Sold',
      statusReserved: 'Reserved',
      statusUnknown: 'Unknown',
      confirmPurchase: 'Are you sure to purchase {name}? Price: {price}円',
      purchaseSuccess: 'Purchase successful! Product has been marked as sold and seller balance has been increased.',
      purchaseFailed: 'Purchase failed',
      purchaseFailedRetry: 'Purchase failed, please try again later',
      unknownSeller: 'Unknown Seller',
      loadProductFailed: 'Failed to get product details'
    },
    products: {
      statusAvailable: 'Available',
      statusSold: 'Sold',
      statusReserved: 'Reserved'
    },
    nav: {
      home: 'Home',
      buy: 'Buy',
      sell: 'Sell Your Game',
      profile: 'User Settings',
      login: 'Login',
      logout: 'Logout',
      admin: 'Admin',
      confirmLogout: 'Are you sure you want to logout?',
      logoutSuccess: 'Logout successful',
      logoutFailed: 'Logout failed',
      logoutFailedRetry: 'Logout failed, please try again'
    },
    withdrawal: {
      completeProfileFirst: 'Please complete your profile information before applying for withdrawal',
      completeProfile: 'Please complete your profile information',
      validAmount: 'Please enter a valid withdrawal amount',
      amountExceedsBalance: 'Withdrawal amount cannot exceed current balance',
      submitted: 'Withdrawal application submitted, pending review',
      failed: 'Withdrawal application failed',
      failedRetry: 'Withdrawal application failed, please try again later'
    }
  },
  zh: {
    common: {
      loading: '加载中...',
      cancel: '取消',
      edit: '编辑',
      confirm: '确定'
    },
    home: {
      hotProducts: '热门商品',
      viewAll: '查看全部',
      announcement: '公告',
      customerService: '客服',
      noProducts: '暂无商品',
      platformAnnouncement: '平台公告',
      selectAnnouncementTip: '请选择要查看的公告',
      contactCustomerService: '联系客服',
      scanQRCodeTip: '扫描二维码联系客服',
      noCustomerQR: '暂无客服二维码',
      navProcess: '【公告】交易流程',
      navUnfreeze: '【公告】VIP服务',
      navSafety: '【公告】禁止私自发送游戏数据和SNS账号',
      navRules: '【公告】解冻业务',
      navContact: '【公告】充值和提现时间',
      navJiHuo: '【公告】账户激活',
      notifications: '通知',
      noNotifications: '暂无通知',
      markAsRead: '标记为已读'
    },
    register: {
      title: '注册',
      username: '用户名',
      usernameHint: '请输入用户名',
      usernameRule: '用户名必须为3-20个字符',
      password: '密码',
      passwordHint: '请输入密码',
      passwordRule: '密码至少需要6个字符',
      registering: '注册中...',
      submit: '注册',
      hasAccountText: '已有账号？',
      loginNow: '立即登录'
    },
    register: {
      title: 'Register',
      username: 'Username',
      usernameHint: 'Enter your username',
      password: 'Password',
      passwordHint: 'Enter your password',
      submit: 'Register',
      registering: 'Registering...',
      completeInfo: 'Please enter your username and password',
      success: 'Registration successful',
      failed: 'Registration failed',
      failedRetry: 'Registration failed, please try again',
      usernameEmpty: 'Please enter username',
      usernameMin: 'Username must be at least 3 characters',
      usernameMax: 'Username must be no more than 20 characters',
      usernameInvalid: 'Username can only contain letters, numbers and underscores',
      usernameValid: 'Username is valid',
      passwordEmpty: 'Please enter password',
      passwordMin: 'Password must be at least 8 characters',
      passwordOnlyAllowed: 'Password can only contain letters and numbers',
      passwordNeedNumber: 'Password must contain numbers',
      passwordNeedLetter: 'Password must contain letters',
      passwordValid: 'Password is valid',
      hasAccountText: 'Already have an account?',
      loginNow: 'Login now'
    },
    product: {
      editTitle: '编辑商品',
      uploadTitle: '上传商品',
      editSubtitle: '修改您的商品信息',
      uploadSubtitle: '添加新商品出售',
      name: '商品名称',
      nameHint: '请输入商品名称',
      nameRule: '商品名称必填',
      price: '价格',
      priceHint: '请输入价格（日元）',
      priceRule: '价格必须为正数',
      description: '描述',
      descriptionHint: '请输入商品描述',
      descriptionRule: '描述必填',
      image: '商品图片',
      selectImage: '选择图片',
      reSelectImage: '重新选择图片',
      updating: '更新中...',
      submitting: '提交中...'
    },
    products: {
      searchPlaceholder: '搜索商品...',
      newest: '最新',
      priceLowToHigh: '价格：从低到高',
      priceHighToLow: '价格：从高到低',
      search: '搜索',
      empty: '未找到商品',
      emptySubtext: '尝试调整搜索条件或上传商品',
      upload: '上传商品'
    },
    noAccountText: '没有账号？',
    registerNow: '立即注册',
    login: {
      title: '登录',
      usernameHint: '请输入用户名',
      passwordHint: '请输入密码',
      rememberUsername: '记住用户名',
      rememberPassword: '记住密码',
      loggingIn: '登录中...',
      submit: '登录',
      noAccountText: '没有账号？',
      registerNow: '立即注册',
      completeInfo: '请完善您的个人信息',
      success: '登录成功',
      error: '登录失败',
      retry: '请重试'
    },
    nav: {
      home: '首页',
      buy: '购买',
      sell: '出售你的游戏',
      profile: '用户设置',
      login: '登录',
      logout: '登出',
      admin: '管理员'
    },
    site: {
      title: '游戏交易'
    },
    tips: {
      title: '温馨提示',
      reviewRequired: '商品提交后需要管理员审核',
      updateReviewRequired: '商品更新后需要管理员重新审核',
      ensureValid: '请确保商品信息真实有效',
      statusReset: '编辑后商品状态将重置为待审核'
    },
    profile: {
      title: '个人信息',
      personalInfo: '个人信息',
      balance: '账户余额',
      myProducts: '出售的商品',
      withdrawalHistory: '提现记录',
      username: '用户名',
      realName: '真实姓名',
      phone: '电话号码',
      email: '邮箱',
      emailPlaceholder: '请输入邮箱地址',
      emailHelp: '用于接收重要通知',
      emailInvalid: '邮箱格式不正确',
      bankAccount: '账户号码',
      bankName: '银行名称',
      bankNamePlaceholder: '请输入银行名称',
      bankNameHelp: '请输入银行名称',
      bankNameRequired: '银行名称不能为空',
      bankBranch: '支行名称',
      bankBranchPlaceholder: '请输入支行名称',
      bankBranchHelp: '请输入支行名称',
      bankBranchRequired: '支行名称不能为空',
      idCardFront: '身份证正面',
      idCardFrontHelp: '上传身份证正面照片（可选）',
      idCardBack: '身份证反面',
      idCardBackHelp: '上传身份证反面照片（可选）',
      uploadSuccess: '上传成功',
      uploadFailed: '上传失败',
      address: '联系地址',
      katakanaName: '片假名',
      delete: '删除',
      productDetails: '商品详情',
      productName: '商品名称',
      productPrice: '商品价格',
      productImage: '商品图片',
      seller: '卖家',
      reviewStatus: '审核状态',
      saleStatus: '销售状态',
      content: '内容',
      rejectionReason: '拒绝原因',
      publishTime: '发布时间',
      updateTime: '更新时间',
      noDescription: '暂无描述',
      noWithdrawalRecords: '暂无提现记录',
      confirmDeleteWithdrawal: '确认删除这条提现记录吗？',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      withdrawalSubmitted: '提现申请已提交,等待审核',
      available: '在售',
      sold: '已售',
      removed: '已下架',
      usernameHelp: '用户名用于登录,可以修改但不能与其他用户重复',
      realNameHelp: '提现时需要验证,请填写真实姓名',
      katakanaNameHelp: '请填写对应的片假名',
      phoneHelp: '用于重要通知',
      bankAccountHelp: '提现时使用',
      addressHelp: '用于邮寄或联系,请填写详细地址',
      requiredNote: '* 标记的字段为必填项,提现前必须完善',
      save: '保存资料',
      applyWithdrawal: '申请提现',
      noProducts: '暂无出售商品',
      viewDetails: '查看详情',
      remainingAmount: '剩余提现金额',
      totalAmount: '总金额',
      invalidUserInfo: '用户信息无效',
      loadProfileFailed: '获取用户资料失败',
      loadProfileFailedRetry: '获取用户资料失败,请重试',
      correctFormErrors: '请修正表单中的错误',
      saveSuccess: '资料保存成功',
      usernameExists: '用户名已被其他用户使用',
      phoneFormatInvalid: '电话号码格式不正确',
      saveFailedRetry: '保存失败,请稍后重试',
      realNamePlaceholder: '请输入真实姓名',
      katakanaNamePlaceholder: '请输入片假名',
      phonePlaceholder: '请输入联系电话',
      bankAccountPlaceholder: '请输入银行账户',
      addressPlaceholder: '请输入详细地址',
      usernameRequired: '用户名不能为空',
      usernameMinLength: '用户名至少3个字符',
      usernameMaxLength: '用户名不能超过20个字符',
      usernameInvalid: '用户名只能包含字母、数字、下划线和中文',
      realNameRequired: '真实姓名不能为空',
      realNameMinLength: '真实姓名至少2个字符',
      realNameMaxLength: '真实姓名不能超过10个字符',
      realNameInvalid: '真实姓名只能包含中文、英文和空格',
      katakanaNameRequired: '片假名不能为空',
      katakanaNameMinLength: '片假名至少2个字符',
      katakanaNameMaxLength: '片假名不能超过20个字符',
      phoneRequired: '联系电话不能为空',
      bankAccountRequired: '银行账户不能为空',
      addressRequired: '联系地址不能为空',
      loadWithdrawalFailed: '加载提现记录失败',
      accountFrozen: '账户已经被冻结，请联系工作人员',
      checkUserStatusFailed: '检查用户状态失败',
      checkUserStatusFailedRetry: '检查用户状态失败，请稍后重试',
      completeProfileFirst: '请先完善个人资料后再申请提现',
      insufficientBalance: '余额不足,无法申请提现',
      confirmWithdrawal: '确认申请提现{amount}円吗?提现后余额将清零。',
      withdrawalSubmitted: '提现申请已提交,等待审核',
      withdrawalFailed: '提现申请失败',
      withdrawalFailedRetry: '提现申请失败,请稍后重试',
      deleteWithdrawalFailed: '删除提现记录失败',
      deleteFailedRetry: '删除失败,请稍后重试',
      statusApproved: '已通过',
      statusPending: '待审核',
      statusRejected: '已拒绝',
      statusFrozen: '冻结中，请联系工作人员',
      statusUnknown: '未知状态',
      statusAvailable: '在售',
      statusSold: '已售出',
      statusRemoved: '已下架',
      requiredField: '请填写此字段'
    },
    detail: {
      back: '返回',
      publishTime: '发布时间',
      productDescription: '商品描述',
      sellerInfo: '卖家信息',
      seller: '卖家',
      productStatus: '商品状态',
      purchase: '购买',
      productNotFound: '商品不存在',
      productNotFoundMessage: '抱歉，您访问的商品不存在或已下架',
      statusAvailable: '在售',
      statusSold: '已被购买',
      statusReserved: '已预订',
      statusUnknown: '未知',
      confirmPurchase: '确定要购买{name}吗？价格：{price}円',
      purchaseSuccess: '购买成功！商品已标记为已出售，卖家余额已增加。',
      purchaseFailed: '购买失败',
      purchaseFailedRetry: '购买失败，请稍后重试',
      unknownSeller: '未知卖家',
      loadProductFailed: '获取商品详情失败'
    },
    products: {
      statusAvailable: '在售',
      statusSold: '已出售',
      statusReserved: '已预订'
    },
    nav: {
      home: '首页',
      buy: '购买',
      sell: '出售你的游戏',
      profile: '用户设置',
      login: '登录',
      logout: '登出',
      admin: '管理员',
      confirmLogout: '确定要退出登录吗？',
      logoutSuccess: '已退出登录',
      logoutFailed: '登出失败',
      logoutFailedRetry: '登出失败，请重试'
    },
    withdrawal: {
      completeProfileFirst: '请先完善个人资料后再申请提现',
      completeProfile: '请先完善个人资料',
      validAmount: '请输入有效的提现金额',
      amountExceedsBalance: '提现金额不能超过当前余额',
      submitted: '提现申请已提交，等待审核',
      failed: '提现申请失败',
      failedRetry: '提现申请失败，请稍后重试'
    }
  }
}

const i18n = new VueI18n({
  locale: 'ja', // 默认语言改为日语
  messages
})

export default i18n
